import { FETCH_DEALS_WITH_FORECAST_CATEGORIES_SUCCEEDED } from '../actions/ActionTypes';
import { requestStatuses } from '../constants/RequestStatusTypes';
const initialState = {
  status: requestStatuses.UNINITIALIZED,
  total: 0
};
export default function dealsWithForecastCategories(state = initialState, action) {
  const {
    payload
  } = action;
  switch (action.type) {
    case FETCH_DEALS_WITH_FORECAST_CATEGORIES_SUCCEEDED:
      return Object.assign({}, state, {
        status: requestStatuses.SUCCEEDED,
        total: payload.total
      });
    default:
      return state;
  }
}